export default class Validator {
    constructor() {
        this.decimalSeparator = ',';
    }

    zipcode(value) {
        return !!(value.match(/^(LT-)?\s?([0-9]{5})$/i));
    }
}
